module.exports = __webpack_public_path__ + "img/lvmi.f7a2590e.png";